class SoftpayController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'IntegrationRepository'
		'ToastService'

	integrationId: 'softpay'

	initialize: ->
		@isNew = @configuration.is_active != true

	afterDisconnect: ->
		@configuration = {}

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data

	afterDisconnect: ->
		@configuration = {}
